import { render } from "./ModalEditor.vue?vue&type=template&id=1163a7f2&scoped=true&lang=pug"
import script from "./ModalEditor.vue?vue&type=script&lang=js"
export * from "./ModalEditor.vue?vue&type=script&lang=js"

import "./ModalEditor.vue?vue&type=style&index=0&id=1163a7f2&lang=scss"
import "./ModalEditor.vue?vue&type=style&index=1&id=1163a7f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1163a7f2"]])

export default __exports__